<script>
import { sync } from 'vuex-pathify';
import inputTypeOptions from '../_field-types/inputs';
import dataTypeOptions from '../_field-types/data';
import presentationTypeOptions from '../_field-types/presentation';
import CostsTableField from '@/modules/document/_component/fields/CostsTableField.vue';
import ResourcesTableField from '@/modules/document/_component/fields/ResourcesTableField.vue';

export default {
    data() {
        return {
            inputTypeOptions,
            dataTypeOptions,
            presentationTypeOptions,
            widthOptions: [
                {
                    text: '33%',
                    value: '4',
                },
                {
                    text: '50%',
                    value: '6',
                },

                {
                    text: '66%',
                    value: '8',
                },
                {
                    text: '100%',
                    value: '12',
                },
            ],
            typeOptions: [
                {
                    text: 'Input',
                    value: 'input',
                },
                {
                    text: 'Data',
                    value: 'data',
                },
                {
                    text: 'Presentation',
                    value: 'presentation',
                },
            ],
        };
    },
    computed: {
        ...sync('document', [
            'field',
            'field@label',
            'field@type',
            'field@value',
            'field@options.options',
        ]),
        width: sync('document/field@options.width'),
        category: sync('document/field@options.category'),
        inputType: sync('document/field@options.input_type'),
        presentationType: sync('document/field@options.presentation_type'),
        selectedDataColumns: sync('document/field@options.data_columns'),
        dataColumnOptions() {
            if (this.type === 'data' && this.value) {
                const dataType = this.dataTypeOptions.find(option => option.value === this.value);

                if (dataType?.columns) {
                    return dataType.columns;
                }
            }

            return [];
        },
        defaultValueComponent() {
            if (this.type === 'input' && this.inputType) {
                const inputType = this.inputTypeOptions.find(option => option.value === this.inputType);

                if (inputType.component) {
                    return inputType.component;
                }
            }

            if (this.type === 'presentation' && this.presentationType) {
                const presentationType = this.presentationTypeOptions.find(option => option.value === this.presentationType);

                if (presentationType.component) {
                    return presentationType.component;
                }
            }

            return null;
        },
        fieldOptionsComponent() {
            if (this.type === 'data' && this.field.value === 'event.costs') {
                return CostsTableField;
            }

            if (this.type === 'data' && this.field.value === 'event.resources') {
                return ResourcesTableField;
            }

            if (this.type === 'input' && this.inputType) {
                const inputType = this.inputTypeOptions.find(option => option.value === this.inputType);

                if (inputType.optionsComponent) {
                    return inputType.optionsComponent;
                }
            }

            return null;
        },
    },
};
</script>

<template>
    <div>
        <b-form-group
            label="Label"
            label-cols="4"
        >
            <b-form-input
                v-model="label"
            />
        </b-form-group>

        <b-form-group
            v-slot="{ ariaDescribedby }"
            label="Width"
            label-cols="4"
        >
            <b-form-radio-group
                id="btn-radios-1"
                v-model="width"
                :options="widthOptions"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                buttons
            />
        </b-form-group>

        <b-form-group
            v-slot="{ ariaDescribedby }"
            label="Type"
            label-cols="4"
        >
            <b-form-radio-group
                id="btn-radios-1"
                v-model="type"
                :options="typeOptions"
                :aria-describedby="ariaDescribedby"
                button-variant="outline-primary"
                buttons
            />
        </b-form-group>

        <b-form-group
            v-if="type === 'input'"
            label="Input type"
            label-cols="4"
        >
            <b-form-select
                v-model="inputType"
                :options="inputTypeOptions"
            />
        </b-form-group>

        <b-form-group
            v-if="type === 'data'"
            label="Data field"
            label-cols="4"
        >
            <b-form-select
                v-model="value"
                :options="dataTypeOptions"
            />
        </b-form-group>

        <b-form-group
            v-if="type === 'data' && dataColumnOptions.length > 0"
            label="Columns"
            label-cols="4"
        >
            <b-form-checkbox-group
                v-model="selectedDataColumns"
                :options="dataColumnOptions"
                stacked
            />
        </b-form-group>

        <b-form-group
            v-if="type === 'presentation'"
            label="Presentation type"
            label-cols="4"
        >
            <b-form-select
                v-model="presentationType"
                :options="presentationTypeOptions"
            />
        </b-form-group>

        <b-form-group
            v-if="fieldOptionsComponent"
            label="Options"
            label-cols="4"
            content-cols="8"
        >
            <component
                :is="fieldOptionsComponent"
                v-model="options"
                :field="field"
            />
        </b-form-group>

        <b-form-group
            v-if="defaultValueComponent"
            label="Default value"
            label-cols="4"
            content-cols="8"
        >
            <component
                :is="defaultValueComponent"
                v-model="value"
                :field="field"
            />
        </b-form-group>
    </div>
</template>

<style
    scoped
    lang="scss"
>

</style>
